<div class="eod-input" [ngClass]="{'input--lg': textboxInput?.size==='lg','input--sm': textboxInput?.size==='sm','input--md': textboxInput?.size==='md','--is-icon': textboxInput?.iconSrc, '--currency-input': textboxInput?.currencyText,'--is-chevron': textboxInput?.chevronInput, '--phone-code-input': textboxInput?.countryPhoneCode && textboxInput?.type === 'tel'}">
  @if (textboxInput?.label) {
    <label [attr.for]="textboxInput?.id" class="form-label">{{ textboxInput?.label }}@if (textboxInput?.required) {<span class="required-field">*</span>}
    </label>
  }

  <div [ngClass]="innerDivClasses">
    <input
        #inputElement
        [id]="textboxInput?.id"
        [type]="(textboxInput?.type==='password' && showPassword) ? 'text' : (textboxInput?.type==='input' ? 'text' : textboxInput?.type)"
        class="form-control"
        [ngClass]="{'is-valid': textboxInput?.isValid, 'is-invalid': textboxInput?.isInvalid, '--is-date': textboxInput?.type==='date'}"
        [attr.placeholder]="textboxInput?.placeholder"
        [attr.maxlength]="(textboxInput?.maxLength ) ? textboxInput?.maxLength : null"
        [attr.max]="textboxInput?.max != null ? textboxInput?.max : null"
        [attr.min]="textboxInput?.min != null ? textboxInput?.min : null"
        [value]="textboxInput?.value"
        [disabled]="textboxInput?.disabled"
        [readOnly]="textboxInput?.readonly"
        (input)="onInput($event)"
        (blur)="onBlur($event)"
        (keypress)="onKeypress($event)" />

    <!-- Left icon slot: src icon when positioned left -->
    @if (hasLeftIcon) {
      <span class="input-icon input-icon--left">
        <img [class]="'icon-' + textboxInput?.iconColor" [src]="textboxInput?.iconSrc" alt="" />
      </span>
    }

    <!-- Right icon slot: src on right, validation icons, password toggle -->
    @if (hasRightIcons) {
      <span class="input-icon input-icon--right">
        @if (textboxInput?.iconSrc && effectiveIconPosition === 'right') {
          <img [class]="'icon-' + textboxInput?.iconColor" [src]="textboxInput?.iconSrc" alt="" />
        }
        @if (showValidationOnRight) {
          @if (textboxInput?.isValid) {
            <img [src]="ICONS.CHECK" alt="" class="icon-success">
          }
          @if (textboxInput?.isInvalid) {
            <img [src]="ICONS.ALERT_ONLY_FILLED" alt="" class="icon-error">
          }
        }
        @if (textboxInput?.type === 'password') {
          <button type="button" class="show-password" (click)="togglePasswordVisibility()" [attr.aria-pressed]="showPassword">
            <img [src]="showPassword ? ICONS.EYE_OFF : ICONS.EYE" alt="toggle" />
          </button>
        }
      </span>
    }

    @if (textboxInput?.currencyText){
      <span class="currency-text">{{ textboxInput?.currencyText }}</span>
    }
    @if (textboxInput?.countryPhoneCode && textboxInput?.type === 'tel'){
      <span class="country-phone-code">{{ textboxInput?.countryPhoneCode }}</span>
    }
  </div>


   @if (textboxInput?.helperText || textboxInput?.rightSideText || (textboxInput?.maxLengthCount && !textboxInput?.rightSideText)) {<div class="bottom-helper-text" [class]="[(!textboxInput?.helperText && 'align-right')]">
    @if (textboxInput?.helperText) {<small class="helper-text">{{ textboxInput?.helperText }}</small>}
    @if (textboxInput?.rightSideText) {<small  [class]="['helper-text', textboxInput?.rightSideTextClass]" >{{ textboxInput?.rightSideText }}</small>}
    @if (textboxInput?.maxLengthCount && !textboxInput?.rightSideText) {<small class="right-helper-text">{{currentLength}} / {{ textboxInput?.maxLengthCount }}</small>}
  </div>}

</div>